const pad2 = (n) => String(n).padStart(2, '0');

export const toIsoDate = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

const quarterlyTerms = (year) => [
  { start: new Date(year, 0, 1), end: new Date(year, 2, 31) },
  { start: new Date(year, 3, 1), end: new Date(year, 5, 30) },
  { start: new Date(year, 6, 1), end: new Date(year, 8, 30) },
  { start: new Date(year, 9, 1), end: new Date(year, 11, 31) },
];

export const currentTermRange = (today = new Date()) => {
  const yearStart = new Date(today.getFullYear(), 0, 1);
  return { startDate: toIsoDate(yearStart), endDate: toIsoDate(today) };
};

export const timeFirstFormattedDate = (dateString) => {
  const date = new Date(dateString);

  const ordinal = (n) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const formattedTime = date.toLocaleString(undefined, {
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h12',
  });

  const day = ordinal(date.getDate());
  const month = date.toLocaleString(undefined, {
    month: 'long',
  });

  return `${formattedTime} on ${day} ${month}`.toLowerCase();
};

export const formattedDate = (dateString) => {
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };
  const date = new Date(dateString);
  return date.toLocaleString(undefined, options);
};
export const dateOnly = (dateString) => {
  const date = new Date(dateString);
  const dateReady = date.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
  });
  return dateReady;
};

export function getRelativeTime(scheduledDateString) {
  const scheduledDate = new Date(scheduledDateString);
  const now = new Date();
  

  const diffTime = scheduledDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const scheduledDay = new Date(
    scheduledDate.getFullYear(), 
    scheduledDate.getMonth(), 
    scheduledDate.getDate()
  );
  
 
  if (scheduledDay.getTime() === today.getTime()) {
    return "Today";
  }
  
  const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
  if (scheduledDay.getTime() === tomorrow.getTime()) {
    return "Tomorrow";
  }
 
  if (diffDays >= 2 && diffDays <= 6) return `${diffDays} Days`;
  if (diffDays >= 7 && diffDays < 14) return "1 Week";
  if (diffDays >= 14 && diffDays < 21) return "2 Weeks";
  if (diffDays >= 21 && diffDays < 28) return "3 Weeks";
  if (diffDays >= 28 && diffDays < 35) return "4 Weeks";
  if (diffDays >= 35 && diffDays < 42) return "5 Weeks";
  if (diffDays >= 42 && diffDays < 49) return "6 Weeks";
  if (diffDays >= 49 && diffDays < 56) return "7 Weeks";
  

  if (diffDays >= 56 && diffDays < 90) return "2+ Months";
  if (diffDays >= 90) return "3+ Months";
  
  return "Future";
}
